import { useState } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import StarFilled from '@icon/StarFilled';
import { Spacings, breakpoints } from '@styles/index';

const Star = styled(StarFilled)`
  margin-left: ${Spacings.SPACING_2B};
  cursor: ${({ isReadOnly }) => (isReadOnly ? 'auto' : 'pointer')};
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 32px;
    height: 32px;
    :first-child {
      margin-left: 0;
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
`;

const Rating = ({
  maxRating,
  setRating,
  value,
  className,
  isReadOnly,
  starColor
}) => {
  const data = value + 1;
  const [starNumber, setStarNumber] = useState(data);
  const handleMouseLeave = () => {
    if (isReadOnly) return;
    setStarNumber(data);
  };

  const handleMouseEnter = (index) => () => {
    if (isReadOnly) return;
    setStarNumber(index + 2);
  };
  return (
    <Wrapper onMouseLeave={handleMouseLeave} className={className}>
      {Array.from({ length: maxRating }, (v, k) => k + 1).map(
        (rating, index) => (
          <div
            key={rating}
            onMouseEnter={handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            <Star
              isReadOnly={isReadOnly}
              color={
                rating < starNumber
                  ? starColor || 'var(--color-i-orange-1)'
                  : 'var(--color-divider)'
              }
              size={Spacings.SPACING_8B}
              onClick={setRating(rating)}
              key={rating}
            />
          </div>
        )
      )}
    </Wrapper>
  );
};
export default Rating;
Rating.propTypes = {
  maxRating: PropTypes.number,
  setRating: PropTypes.func,
  value: PropTypes.number.isRequired,
  className: PropTypes.string,
  isReadOnly: PropTypes.bool,
  starColor: PropTypes.string
};
Rating.defaultProps = {
  maxRating: 5,
  setRating: () => {},
  className: '',
  isReadOnly: false,
  starColor: 'var(--color-i-orange-1)'
};
